module.exports = __webpack_public_path__ + "img/icon-chart-flow.7bf6039c.svg";